import { gql } from '@src/__generated__';

export const FIND_VOYAGE_VIBE_STATES = gql(`
  query findVoyageVibeStates(
    $tripProfileId: ID!
    $specificQuestionIds: [ID!]!
  ) {
    findVoyageVibeStates(
      tripProfileId: $tripProfileId,
      where: { questionId_in: $specificQuestionIds }
    ) {
      id
      tripProfileId
      questionId
      title
      rating
      rank
    }
  }
`);

export const FIND_VOYAGE_VIBE_STATES_EXPANDED = gql(`
  query findVoyageVibeStatesExpanded(
    $tripProfileId: ID!
    $specificQuestionIds: [ID!]!
  ) {
    findVoyageVibeStates(
      tripProfileId: $tripProfileId,
      where: { questionId_in: $specificQuestionIds }
    ) {
      id
      tripProfileId
      questionId
      title
      rating
      rank
      ranks {
        rank
        text
        id
        oaiKey
      }
    }
  }
`);

export const UPSERT_VOYAGE_VIBE_STATE = gql(`
  mutation upsertVoyageVibeState(
    $id: ID
    $tripProfileId: ID!
    $questionId: ID!
    $title: String
    $rating: Int
  ) {
    upsertVoyageVibeState(
      id: $id
      tripProfileId: $tripProfileId
      questionId: $questionId
      title: $title
      rating: $rating
    ) {
      id
      tripProfileId
      questionId
      title
      rating
    }
  }
`);

export const UPSERT_VOYAGE_VIBE_STATES = gql(`
  mutation upsertAllVoyageVibeStates(
    $voyageVibeStates: [voyageVibeStateInput!]!
  ) {
    upsertAllVoyageVibeStates(
      voyageVibeStates: $voyageVibeStates
    ) {
      id
    }
  }
`);

export const VOYAGE_VIBE_RESULTS = gql(`
  query findVoyageVibeResults(
    $tripProfileId: ID!
  ) {
    findVoyageVibeResults(tripProfileId: $tripProfileId) {
      id
      tripProfileId
      tripProfileTitle
      destinationNutsId
      destinationName
      nameLocal
      nameDisplay
      nameLatin
      nameEn
      type
      nutId
      wikidataId
      openStreetMapId
      mapboxId
      photoUrl
      formattedAddress
      editorialSummary
      googleMapsUri
      attractionTypeRank
      experienceDurationMin
      experienceDurationMax
      effortRating
      percentOther
      percentShopping
      percentCityTour
      percentOutdoorAdventure
      percentVisitMuseumGallery
      percentWalkingMeanderingLocally
      percentAttendPerformanceFestival
      percentOutdoorRecreationExploration
      resultOther
      resultShopping
      resultCityTour
      resultOutdoorAdventure
      resultVisitMuseumGallery
      resultWalkingMeanderingLocally
      resultAttendPerformanceFestival
      resultOutdoorRecreationExploration
      physicalAdventure
      interactivityLocals
      learning
      resultSum
      scoreActAttr
      rank
    }
  }
`);

export const WRITE_ATTR_STATES = gql(`
  mutation WriteAttractionStates(
    $tripProfileId: ID!
    $attractionStates: [AttractionStateInput!]!
  ) {
    writeAttractionStates(
      tripProfileId: $tripProfileId
      attractionStates: $attractionStates
    ) {
      id
      tripProfileId
      attractionId
      interest
    }
  }
`);

export const FIND_ATTR_STATES = gql(`
  query findAttractionStates(
    $tripProfileId: ID!
  ) {
    findAttractionStates(
      tripProfileId: $tripProfileId
    ) {
      id
      attractionId
      interest
    }
  }
`);
